import MuiDrawer, { DrawerProps, drawerClasses } from "@mui/material/Drawer";
import { CSSObject, Theme, styled } from "@mui/material/styles";

const openedMixin = (theme: Theme, width: number | string): CSSObject => ({
  width: width,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (
  theme: Theme,
  extraClosedMixin?: CSSObject,
): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  ...extraClosedMixin,
});

export const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) =>
    prop !== "clippedDrawer" &&
    prop !== "width" &&
    prop !== "hasFooter" &&
    prop !== "paperWidth" &&
    prop !== "drawerExtraClosedMixin" &&
    prop !== "paperExtraClosedMixin",
})<{
  clippedDrawer?: boolean;
  width: number | string;
  hasFooter: boolean;
  paperWidth?: string | number;
  drawerExtraClosedMixin?: (theme: Theme) => CSSObject;
  paperExtraClosedMixin?: (theme: Theme) => CSSObject;
}>(({
  theme,
  open,
  width,
  hasFooter,
  paperWidth,
  drawerExtraClosedMixin,
  paperExtraClosedMixin,
}) => {
  const drawerClosedExtraCSS: CSSObject | undefined = drawerExtraClosedMixin
    ? drawerExtraClosedMixin(theme)
    : undefined;

  const paperClosedExtraCSS: CSSObject | undefined = paperExtraClosedMixin
    ? paperExtraClosedMixin(theme)
    : undefined;

  return {
    width: width,
    flexShrink: 0,
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    overflowY: hasFooter ? "hidden" : "auto",
    ...(open && {
      ...openedMixin(theme, width),
      "& .MuiDrawer-paper": openedMixin(theme, paperWidth || width),
    }),
    ...(!open && {
      ...closedMixin(theme, drawerClosedExtraCSS),
      "& .MuiDrawer-paper": closedMixin(theme, paperClosedExtraCSS),
    }),
    [theme.breakpoints.down("sm")]: {
      ...closedMixin(theme, drawerClosedExtraCSS),
      "& .MuiDrawer-paper": closedMixin(theme, paperClosedExtraCSS),
    },
  };
});
